// src/pages/FavoritesPage.js
import React from 'react';
import TrialExpiredOverlay from '../components/TrialExpiredOverlay';
import './FavoritesPage.css';

function FavoritesPage() {
  return (
    <div className="favorites-page" style={{ position: 'relative', minHeight: '500px' }}>
      <TrialExpiredOverlay section="favorites" />
      <div className="favorites-header">
        <h1>Favorites</h1>
        <p>Your saved articles and conferences</p>
      </div>

      <div className="favorites-content">
        <div className="favorites-empty-state">
          <p>Favorites feature coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default FavoritesPage;
